module.exports = __webpack_public_path__ + "static/media/welcomeImg.443bca22.png";